export class ApproveContractRequest {
    contractId: number;
    approvedBy: string;
}